/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown as DropdownAnt } from 'antd'
import { useState } from 'react'

import AccountMenu from '@mercadoni/sinister/dist/cjs/accountMenu'

import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication/contexts'

const DropdownLogic = ({
  Wrapper,
  children,
}: {
  Wrapper: any
  children: any
}) => {
  const { onClickAccountOption, copies, enabledQuotes } = useHeaderContext()
  const { isLogged } = UseLoggedContext()
  const [open, setOpen] = useState(false)

  const onClickOption = (value: any) => {
    onClickAccountOption?.(value)
    setOpen(false)
  }

  return (
    <Wrapper
      dropdownRender={() => (
        <AccountMenu
          onClickOption={onClickOption}
          copies={copies}
          enabledQuotes={enabledQuotes}
        />
      )}
      trigger={['click']}
      onOpenChange={(state: any) => setOpen(state)}
      open={open}
      placement="bottomLeft"
      overlayStyle={{
        padding: '8px 16px',
        backgroundColor: 'white',
        borderRadius: 4,
        minWidth: isLogged ? '300px' : '',
      }}
      getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
    >
      {children}
    </Wrapper>
  )
}

const Dropdown = ({ children }: { children: any }) => (
  <DropdownLogic Wrapper={DropdownAnt}>{children}</DropdownLogic>
)

export default Dropdown
